const en = {
  mediaLibrary: {
    title: "Media Library",
    searchPlaceholder: "Search files...",
    allFiles: "All Files",
    filterAll: "All Types",
    filterImages: "Images",
    filterDocuments: "Documents",
    filterVideos: "Videos",
    filterAudio: "Audio",
    newFolder: "New Folder",
    folderName: "Folder name",
    noFiles: "No files found",
    dropOrClick: "Drop files here or click to upload",
    acceptedFormats: "Images, PDF, Video, Audio, Documents (max 10MB)",
    uploading: "Uploading...",
    uploadingProgress: "Uploading {current} of {total}...",
    selectImage: "Select Image",
    selectFile: "Select File",
    deleteSelected: "Delete",
    copyUrl: "Copy URL",
    copied: "Copied!",
    browseMedia: "Browse Media Library",
    renameFolder: "Rename folder",
    addSubfolder: "Add subfolder",
    subfolderName: "Subfolder name",
    sortNewest: "Newest First",
    sortOldest: "Oldest First",
    sortNameAsc: "Name A-Z",
    sortNameDesc: "Name Z-A",
    sortSizeAsc: "Smallest First",
    sortSizeDesc: "Largest First",
    moveSelected: "Move",
    moveToRoot: "All Files",
    currentFolder: "(current)",
    confirmDelete: "Confirm?",
    renameFile: "Rename",
    editFile: "Edit File",
    fileName: "Filename",
    altText: "Alt Text",
    altTextPlaceholder: "Describe this image for accessibility",
    saveChanges: "Save",
    cancel: "Cancel",
    frequentlyUsed: "Frequently Used",
    deleteWarningTitle: "Delete File",
    deleteWarningMessage: "Are you sure? This action is irreversible.",
    deleteWarningUsageNote:
      "The following files are used in templates. Deleting them may break those templates.",
    deleteAnyway: "Delete",
    usedInTemplates: "Used in {count} template(s)",
    viewGrid: "Grid view",
    viewList: "List view",
    showFolders: "Show folders",
    hideFolders: "Hide folders",
    importFromUrl: "Import from URL",
    importUrlPlaceholder: "https://example.com/image.jpg",
    import: "Import",
    importing: "Importing...",
    importError: "Failed to import from URL",
    conversionLabel: "Size",
    conversionOriginal: "Original",
    conversionSmall: "Small (150px)",
    conversionMedium: "Medium (600px)",
    conversionLarge: "Large (1200px)",
    replaceFile: "Replace File",
    replaceWarningTitle: "Replace File",
    replaceWarningMessage:
      "You are about to replace this file. The replacement must have the same file extension ({extension}).",
    replaceWarningUsageNote:
      "This file is used in {count} template(s). Replacing it will update all references.",
    replaceSelectFile: "Select replacement file",
    replace: "Replace",
    replacing: "Replacing...",
    replaceError: "Failed to replace file",
    saving: "Saving...",
    cropAspectRatio: "Aspect Ratio",
    cropFree: "Free",
    cropSquare: "1:1",
    cropLandscape43: "4:3",
    cropLandscape169: "16:9",
    cropOriginal: "Original",
    cropMaxWidth: "Max Width",
    cropMaxHeight: "Max Height",
    cropOutputSize: "Output Size",
    cropPixels: "px",
    cropOptional: "(optional)",
    storageTooltip: "{used} of {total} used ({remaining} remaining)",
  },
};

export default en;
